import formatDate from '../formatDate';
/** @public */
var formatDates = function (selectTwoDates, dates, format) {
  var startDate = formatDate(dates.startDate, format);
  var endDate = formatDate(dates.endDate, format);
  if (selectTwoDates) {
    return startDate ? "".concat(startDate, " - ").concat(endDate) : null;
  }
  return startDate;
};
export default formatDates;